import { Component, Watch } from 'vue-property-decorator';
import SmartButton from 'tivigi/src/components/SmartButton/SmartButton'


//################ BEGIN Statistikmonitor 3 ################
import SM3Absolut from '../Absolutindikatoren/Absolutindikatoren'
import SM3Base from '../SM3Base/SM3Base';
import SM3Dynamik from '../Dynamik/Dynamik'
import SM3Metropolregionen from '../Metropolregionen/Metropolregionen'
import SM3Top from '../Topindikatoren/Topindikatoren'
import SM3Strukturindikatoren from '../Strukturindikatoren/Strukturindikatoren'
import SM3Startseite from '../Startseite/Startseite'
import SM3Frame from '../SM3Frame/SM3Frame'
//################ END Statistikmonitor 3 ################

import FloatingWindow from 'tivigi/src/components/FloatingWindow/FloatingWindow'

import WithRender from './SM3Frame.html';

@WithRender
@Component({
    components: { FloatingWindow,  SM3Absolut, SM3Dynamik, SM3Metropolregionen, SM3Top, SM3Strukturindikatoren, SM3Startseite, SmartButton }
})
export default class Startseite extends SM3Base {


    
    
}


